import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Container from 'react-bootstrap/Container';
import SeamlessLoopPlayer from "./Itom/SeamlessLoopPlayer";
import Itom from "./Itom";


function App() {
  return (
      <Container fluid="lg" >
          <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Itom />} />
                </Routes>
            </div>
          </BrowserRouter>
      </Container>
  );
}

export default App;
